/**
 * Membership predicate for issue #146: does the signed-in user hold a
 * live `user_site` row for the selected site on THIS console module?
 *
 * The org module's site picker (`my_projects`) and the minetwin module's
 * membership (`user_site`) are different systems — a user can legitimately
 * see a site in the topbar while every minetwin view returns nothing,
 * because `admin_project_ids` derives from `user_site`. This predicate is
 * the client-side mirror of that gate, over the `my_user_sites` view
 * (the caller's own rows).
 *
 * `active` matters: `archive_user` soft-detaches by flipping it false,
 * and an archived membership reads exactly like no membership server-side.
 */
export function hasSiteMembership(
  rows: ReadonlyArray<{ projectId: string; active: boolean }>,
  projectId: string,
): boolean {
  if (!projectId) return false;
  return rows.some((r) => r.projectId === projectId && r.active);
}
